import React, { useCallback, useMemo } from "react";

import { InfiniteScroll } from "./index.jsx";

const defaultFetchParams = {
  filters: {},
  sort: {
    field: "created_at",
    direction: "desc",
  },
};

const InfiniteList = ({
  className = "",
  emptyText = "No results found.",
  // Optional node shown instead of the plain emptyText line (F5 friendly empty states).
  empty,
  fetchUrl,
  fetchParams,
  fetchLimit = 10,
  isFromUsersPage,
  isLeadsPage,
  ItemComponent,
  itemProps,
  onSelectClick,
  scrollableTarget,
  type,
}) => {
  const finalFetchParams = useMemo(
    () => ({ ...defaultFetchParams, ...(fetchParams || {}) }),
    [fetchParams]
  );

  const list = (items) =>
    items.map((item) => (
      <ItemComponent
        item={item}
        key={item.id}
        isFromUsersPage={isFromUsersPage}
        isLeadsPage={isLeadsPage}
        onSelectClick={onSelectClick ? () => onSelectClick(item) : null}
        {...itemProps}
        type={type}
      />
    ));

  return (
    <InfiniteScroll
      fetchUrl={fetchUrl}
      fetchParams={finalFetchParams}
      // Was 5: one row on a wide screen. 15 fills the fold at 3-5 columns
      // without a burst of per-card WhatsApp match requests.
      fetchLimit={isLeadsPage ? 15 : fetchLimit}
      responsive
      scrollableTarget={scrollableTarget}
      isFromUsersPage={isFromUsersPage}
      isLeadsPage={isLeadsPage}
      fillViewport={isLeadsPage}
    >
      {({ items, isLoading }) => (
        <div className={className}>
          {items.length > 0 && list(items)}

          {!isLoading && items.length === 0 && (
            empty ?? (
              <div className="no-results">
                <p>{emptyText}</p>
              </div>
            )
          )}
        </div>
      )}
    </InfiniteScroll>
  );
};

export default InfiniteList;
